import { Offcanvas as ReactOffcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import { CloseIcon } from "../utils/icon.utils";
import styled from "styled-components";

export default function OffCanvas({ children, isOpen, toggle, title }) {
  return (
    <OffcanvasContainer direction="end" isOpen={isOpen} toggle={toggle}>
      <OffcanvasHeader
        className="justify-content-between border-0"
        close={<CloseIcon role="button" onClick={toggle} />}
        toggle={toggle}>
        {title ?? ""}
      </OffcanvasHeader>
      <OffcanvasBody>{children}</OffcanvasBody>
    </OffcanvasContainer>
  );
}

const OffcanvasContainer = styled(ReactOffcanvas)`
  font-size: 0.9rem;

  .offcanvas-title {
    font-size: 1rem;
    font-weight: 600;
  }
`;
